import React from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.css';
import PropTypes from 'prop-types';

class Toastr extends React.Component {

  constructor(props) {
    super(props);

    toastr.options.onHidden = () => this.props.onDismissMessage();
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.show) {
      toastr.clear();
      return;
    }
    if (nextProps.messageType === 'success') {
      toastr.success(nextProps.message);
    }
    if (nextProps.messageType === 'error') {
      toastr.error(nextProps.message);
    }
  }

  render() {
    return <div />;
  }
}

Toastr.propTypes = {
  messageType: PropTypes.string,
  message: PropTypes.string,
  show: PropTypes.bool,
  onDismissMessage: PropTypes.func,
};

export default Toastr;



// WEBPACK FOOTER //
// ./app/components/Toastr/index.js